import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/muhammadnomanibrahim/Comverse Applications/comverse-baseapp-next/components/CollectionPage/CollectionPageAlfa.jsx");
;
import(/* webpackMode: "eager" */ "/Users/muhammadnomanibrahim/Comverse Applications/comverse-baseapp-next/components/scrollToTopHook/ScrollToTop.jsx");
